import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex } from '@chakra-ui/react';
import { OfferEnum, StandardRoomType } from '@whitbread-eos/api';
import { Button, Icon, InfoMessage, SearchIcon } from '@whitbread-eos/atoms';
import { upperFirst } from '@whitbread-eos/utils';
import { add, differenceInDays } from 'date-fns';
import { nanoid } from 'nanoid';
import { useTranslation } from 'next-i18next';
import { useEffect, useRef, useState } from 'react';
import BookingDatepicker from '../BookingDatepicker';
import LocationPicker from '../LocationPicker';
import RoomPicker from '../RoomPicker';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var FIELDS = {
  datepicker: 'datepicker',
  location: 'location',
  occupancy: 'occupancy',
  numberOfNights: 'numberOfNights'
};
export default function SearchComponent(_ref) {
  var _dataStayRules$maxNig, _dataStayRules$maxArr, _partialTranslations$2, _AEMTranslations$acce;
  var defaultLocation = _ref.defaultLocation,
    defaultRooms = _ref.defaultRooms,
    dataStayRules = _ref.dataStayRules,
    dataRoomOccupancyLimitations = _ref.dataRoomOccupancyLimitations,
    partialTranslations = _ref.partialTranslations,
    roomCodes = _ref.roomCodes,
    AEMTranslations = _ref.AEMTranslations,
    locale = _ref.locale,
    screenSize = _ref.screenSize,
    handleButtonClick = _ref.handleButtonClick,
    suggestions = _ref.suggestions,
    onIsSearchActive = _ref.onIsSearchActive,
    onLocationInputChange = _ref.onLocationInputChange,
    onLocationInputClear = _ref.onLocationInputClear,
    onLocationInputFocus = _ref.onLocationInputFocus,
    numberOfNightsComponent = _ref.numberOfNightsComponent,
    promotionComponent = _ref.promotionComponent,
    companyNameComponent = _ref.companyNameComponent,
    searchStyles = _ref.searchStyles,
    onSelectDates = _ref.onSelectDates,
    onOccupancyChange = _ref.onOccupancyChange,
    errorField = _ref.errorField,
    errorMessage = _ref.errorMessage,
    isSearchActive = _ref.isSearchActive,
    mappedRoomLabels = _ref.mappedRoomLabels,
    startDate = _ref.startDate,
    endDate = _ref.endDate,
    isDatepickerError = _ref.isDatepickerError,
    showMultipleRooms = _ref.showMultipleRooms,
    isActiveMatchedOffer = _ref.isActiveMatchedOffer,
    matchedOffer = _ref.matchedOffer,
    channel = _ref.channel,
    isDatePickerFocus = _ref.isDatePickerFocus,
    displayDatesNotification = _ref.displayDatesNotification,
    _ref$searchDisabled = _ref.searchDisabled,
    searchDisabled = _ref$searchDisabled === void 0 ? false : _ref$searchDisabled,
    isPIGroupBookingFormEnabled = _ref.isPIGroupBookingFormEnabled,
    isBBGroupBookingFormEnabled = _ref.isBBGroupBookingFormEnabled,
    isDiscountRateEnabled = _ref.isDiscountRateEnabled,
    isBarrierFreeLabelEnabled = _ref.isBarrierFreeLabelEnabled,
    marginBottom = _ref.marginBottom,
    disableFlip = _ref.disableFlip;
  var isGroupBookingFormMessage = isPIGroupBookingFormEnabled || isBBGroupBookingFormEnabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isLessThanLg = screenSize.isLessThanLg,
    isLessThanMd = screenSize.isLessThanMd,
    isLessThanSm = screenSize.isLessThanSm,
    isLessThanXs = screenSize.isLessThanXs;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    location = _useState2[0],
    setLocation = _useState2[1];
  var mappedDefaultRooms = mapDefaultRoomsForRoomPicker(defaultRooms);
  var getRoomsInitialState = () => {
    var _partialTranslations$;
    if (mappedDefaultRooms.length) {
      return mappedDefaultRooms;
    }
    return [{
      id: nanoid(),
      adults: 1,
      children: 0,
      shouldIncludeCot: false,
      roomType: (partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$ = partialTranslations.content) === null || _partialTranslations$ === void 0 || (_partialTranslations$ = _partialTranslations$.global) === null || _partialTranslations$ === void 0 ? void 0 : _partialTranslations$.double) || StandardRoomType.DB,
      shouldBeAccessible: false
    }];
  };
  var _useState3 = useState(getRoomsInitialState()),
    _useState4 = _slicedToArray(_useState3, 2),
    rooms = _useState4[0],
    setRooms = _useState4[1];
  var isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    var mapped = mapDefaultRoomsForRoomPicker(defaultRooms);
    if (mapped.length) {
      setRooms(mapped);
    }
  }, [defaultRooms]);
  var searchWrapper = searchStyles.searchWrapper,
    locationPickerStyles = searchStyles.locationPickerStyles,
    inputGroupStyles = searchStyles.inputGroupStyles,
    inputElementStyles = searchStyles.inputElementStyles,
    bookingDatepickerSize = searchStyles.bookingDatepickerSize,
    datepickerInputElementStyles = searchStyles.datepickerInputElementStyles,
    iconStyles = searchStyles.iconStyles,
    errorInputGroupStyles = searchStyles.errorInputGroupStyles,
    errorInputElementStyles = searchStyles.errorInputElementStyles,
    errorMarginBottom = searchStyles.errorMarginBottom,
    buttonStyles = searchStyles.buttonStyles,
    roomPickerSize = searchStyles.roomPickerSize,
    roomPickerWrapperStyles = searchStyles.roomPickerWrapperStyles,
    roomPickerInputElementStyles = searchStyles.roomPickerInputElementStyles,
    locationErrorGroupStyles = searchStyles.locationErrorGroupStyles;
  var autocompleteStyles = _objectSpread({
    locationPickerStyles,
    inputGroupStyles,
    inputElementStyles,
    errorMarginBottom
  }, errorField === FIELDS.location && {
    errorInputGroupStyles,
    errorInputElementStyles,
    locationErrorGroupStyles
  });
  var bookingDatepickerStyles = _objectSpread({
    inputGroupStyles,
    bookingDatepickerSize,
    datepickerInputElementStyles,
    iconStyles
  }, (errorField === FIELDS.datepicker || errorField === FIELDS.numberOfNights && isDatepickerError) && {
    errorInputGroupStyles,
    errorInputElementStyles,
    errorMarginBottom
  });
  var queryParams = getMappedInputData();
  var maxNumberOfRooms = getMaxNumberOfRooms();
  var groupBookingMessage = isGroupBookingFormMessage ? partialTranslations.results.notifications.groupBookingFormPageMessage : partialTranslations.results.notifications.groupBookingMessage;
  function getRoomsWarningDescription() {
    if (maxNumberOfRooms === 2 && (matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.cellCode) === OfferEnum.EMPLOYEE) return partialTranslations.results.notifications.emp01groupBookingMessage;else if (isDiscountRateEnabled && matchedOffer !== null && matchedOffer !== void 0 && matchedOffer.corpId) return t("promotion.discountrate.".concat(matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.ratePlanCode, ".roomlimit"), {
      maxRooms: matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.maxRooms
    });else return groupBookingMessage;
  }
  function getCcuiRoomsWarningDescription() {
    if (isDiscountRateEnabled && matchedOffer !== null && matchedOffer !== void 0 && matchedOffer.corpId) return t("promotion.discountrate.".concat(matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.ratePlanCode, ".roomlimit"), {
      maxRooms: matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.maxRooms
    });else return partialTranslations.results.notifications.ccuiGroupBookingMessage;
  }
  return _jsxs(Flex, {
    direction: "column",
    children: [_jsxs(Flex, _objectSpread(_objectSpread(_objectSpread({
      align: "center",
      bgColor: "baseWhite"
    }, searchWrapper), getContainerSpacingStyles(marginBottom)), {}, {
      "data-testid": "search-component",
      onFocus: () => {
        if (onIsSearchActive) {
          onIsSearchActive(true);
        }
      },
      children: [_jsx(LocationPicker, _objectSpread({
        inputPlaceholder: getLocationPlaceholder(),
        defaultInputValue: defaultLocation,
        isLocationRequired: true,
        hasListDivider: false,
        styles: autocompleteStyles,
        onSelectLocation: handleSelectLocation,
        suggestions: suggestions,
        onInputChange: onLocationInputChange,
        onInputClear: onLocationInputClear,
        onInputFocus: onLocationInputFocus
      }, errorField === FIELDS.location && {
        showErrorMessage: true,
        errorMessage: errorMessage
      })), _jsx(BookingDatepicker, _objectSpread(_objectSpread({
        displayDateFormat: "dd MMM yyyy",
        inputPlaceholderDatepicker: getInputPlaceholderDatepicker(),
        maxNumberOfNights: isActiveMatchedOffer && matchedOffer !== null && matchedOffer !== void 0 && matchedOffer.numberOfNights ? Number(matchedOffer.numberOfNights) : dataStayRules && Number(dataStayRules === null || dataStayRules === void 0 || (_dataStayRules$maxNig = dataStayRules.maxNightsLimitation) === null || _dataStayRules$maxNig === void 0 ? void 0 : _dataStayRules$maxNig.maxNights),
        maxArrivalDate: dataStayRules && Number(dataStayRules === null || dataStayRules === void 0 || (_dataStayRules$maxArr = dataStayRules.maxArrivalDateLimitation) === null || _dataStayRules$maxArr === void 0 ? void 0 : _dataStayRules$maxArr.maxArrivalDate),
        datepickerStyles: bookingDatepickerStyles,
        onSelectDates: onSelectDates,
        defaultStartDate: startDate,
        defaultEndDate: endDate,
        partialTranslations: partialTranslations,
        locale: locale,
        isError: isDatepickerError
      }, (errorField === FIELDS.datepicker || errorField === FIELDS.numberOfNights && isDatepickerError) && {
        showErrorMessage: true,
        errorMessage: errorMessage
      }), {}, {
        isLessThanSm: isLessThanSm,
        isDatePickerFocus: isDatePickerFocus,
        displayDatesNotification: displayDatesNotification,
        disableFlip: disableFlip
      })), numberOfNightsComponent, _jsx(RoomPicker, _objectSpread(_objectSpread({
        showMultipleRooms: showMultipleRooms,
        roomPickerInputElementStyles: roomPickerInputElementStyles,
        boxWrapperStyles: roomPickerWrapperStyles,
        roomPickerSize: roomPickerSize,
        onSubmit: rooms => {
          setRooms(rooms);
          onOccupancyChange === null || onOccupancyChange === void 0 || onOccupancyChange();
        },
        initialState: rooms,
        maxNumberOfRooms: maxNumberOfRooms,
        labels: {
          roomsWarningTitle: partialTranslations.results.notifications.groupBookingHeader,
          roomsWarningDescription: getRoomsWarningDescription(),
          roomsWarningDescriptionCCUI: getCcuiRoomsWarningDescription(),
          addMoreRoomsLabel: partialTranslations.content.global.addRoom,
          removeRoomButtonLabel: partialTranslations.form.removeRoom,
          doneButtonLabel: partialTranslations.content.global.done,
          adult: partialTranslations.content.global.adult,
          adults: partialTranslations.content.global.adults,
          adultsLabel: AEMTranslations.adultsLabel,
          adultsMaxPerRoomLabel: partialTranslations.form.adultsHelperText,
          child: partialTranslations.content.global.child,
          children: partialTranslations.content.global.children,
          childrenLabel: AEMTranslations.childrenLabel,
          childrenAgeLabel: partialTranslations.form.childrenHelperText,
          cotLimit: partialTranslations.form.cotLimit,
          cotLabel: partialTranslations.form.includeCot,
          room: partialTranslations.content.global.room,
          rooms: partialTranslations.content.global.rooms,
          roomLabel: partialTranslations.content.global.room,
          roomTypeLabel: AEMTranslations.roomTypeLabel,
          single: partialTranslations.content.global.single,
          double: partialTranslations.content.global.double,
          accessible: isBarrierFreeLabelEnabled ? (_partialTranslations$2 = partialTranslations.content.global.accessibleOrBarrierFree) !== null && _partialTranslations$2 !== void 0 ? _partialTranslations$2 : '' : partialTranslations.content.global.accessible,
          twin: partialTranslations.content.global.twin,
          family: partialTranslations.content.global.family,
          accessibleRoom: (_AEMTranslations$acce = AEMTranslations.accessibleRoom) !== null && _AEMTranslations$acce !== void 0 ? _AEMTranslations$acce : ''
        },
        dataRoomOccupancyLimitations: dataRoomOccupancyLimitations,
        roomCodes: roomCodes,
        screenSize: screenSize
      }, errorField === FIELDS.occupancy && {
        showErrorMessage: true,
        errorMessage: errorMessage
      }), {}, {
        channel: channel
      })), isLessThanSm && errorField === FIELDS.occupancy && errorMessage && _jsx(InfoMessage, {
        infoMessage: errorMessage,
        otherStyles: alertStyles
      }), isLessThanSm && (errorField === FIELDS.datepicker || errorField === FIELDS.numberOfNights) && errorMessage && _jsx(InfoMessage, {
        infoMessage: errorMessage
      }), promotionComponent, _jsx(Button, _objectSpread(_objectSpread({
        size: "md",
        variant: "login",
        name: "search-button",
        isDisabled: searchDisabled
      }, buttonStyles), {}, {
        mt: {
          base: 'md',
          sm: '0'
        },
        onClick: () => handleButtonClick(queryParams),
        children: getButtonContent()
      }))]
    })), isSearchActive && companyNameComponent]
  });
  function getMaxNumberOfRooms() {
    var _dataStayRules$global;
    if (isActiveMatchedOffer) {
      return Number(matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.maxRooms);
    }
    return Number(dataStayRules === null || dataStayRules === void 0 || (_dataStayRules$global = dataStayRules.globalConfig) === null || _dataStayRules$global === void 0 || (_dataStayRules$global = _dataStayRules$global.maxRoomsLim) === null || _dataStayRules$global === void 0 ? void 0 : _dataStayRules$global.maxRooms);
  }
  function getInputPlaceholderDatepicker() {
    if (isDatepickerError) {
      return AEMTranslations === null || AEMTranslations === void 0 ? void 0 : AEMTranslations.datepickerInvalidDates;
    }
    return "".concat(AEMTranslations.datepickerCheckinLabel, " | ").concat(AEMTranslations.datepickerCheckoutLabel);
  }
  function handleSelectLocation(location) {
    setLocation(location);
  }
  function getMappedInputData() {
    if (!location) {
      return;
    }
    var start = startDate !== null && startDate !== void 0 ? startDate : new Date();
    var end = endDate !== null && endDate !== void 0 ? endDate : add(new Date(start), {
      days: 1
    });
    var queryParams = {
      searchTerm: location.suggestion,
      ARRdd: start.getDate(),
      ARRmm: start.getMonth() + 1,
      ARRyyyy: start.getFullYear(),
      nights: differenceInDays(end, start),
      roomsNumber: rooms.length,
      rooms: rooms
    };
    if ('placeId' in location) {
      queryParams.placeId = location.placeId;
    }
    if ('code' in location) {
      queryParams.code = location.code;
    }
    if ('geometry' in location) {
      queryParams.location = location.geometry.coordinates;
    }
    if ('brand' in location) {
      queryParams.brand = location.brand;
    }
    return queryParams;
  }
  function getLocationPlaceholder() {
    var _partialTranslations$3;
    return isLessThanLg && !isLessThanSm ? AEMTranslations.locationPlaceholder : partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$3 = partialTranslations.form) === null || _partialTranslations$3 === void 0 ? void 0 : _partialTranslations$3.where;
  }
  function getButtonContent() {
    if (isLessThanSm && !isLessThanXs) {
      return AEMTranslations.submitButtonLabel;
    }
    if (isLessThanMd && !isLessThanSm) {
      return _jsx(Icon, {
        svg: _jsx(SearchIcon, {
          color: "var(--chakra-colors-baseWhite)"
        })
      });
    }
    return AEMTranslations.submitButtonLabel;
  }
  function mapDefaultRoomsForRoomPicker(rooms) {
    if (!rooms || rooms.length > dataStayRules.maxNightsLimitation.maxNights) return [];
    var filteredRooms = rooms.filter(r => r.adults && r.children !== null && r.children !== undefined && !isNaN(r.children));
    return filteredRooms.map(r => {
      var roomTypeCode = r.roomType;
      var roomType = mappedRoomLabels[roomTypeCode];
      if (!Object.keys(mappedRoomLabels).includes(roomTypeCode)) return _objectSpread(_objectSpread({}, r), {}, {
        adults: 1,
        roomType: mappedRoomLabels.DB,
        shouldBeAccessible: false
      });
      return _objectSpread(_objectSpread({}, r), {}, {
        id: nanoid(),
        roomType: upperFirst(roomType)
      });
    });
  }
}
function getContainerSpacingStyles(marginBottom) {
  var mb = 2;
  return {
    mb: marginBottom !== null && marginBottom !== void 0 ? marginBottom : {
      mobile: 'var(--chakra-space-56)',
      xs: 'var(--chakra-space-52)',
      sm: "".concat(mb, "rem")
    }
  };
}
var alertStyles = {
  w: 'full',
  zIndex: 1,
  _before: {
    content: '" "',
    position: 'absolute',
    top: '-0.15rem',
    right: '1.15rem',
    width: '1.5rem',
    height: '0.75rem',
    zIndex: '-1',
    transform: 'rotate(-45deg)',
    bgColor: 'tooltipError',
    borderRadius: '3'
  }
};